<template>
    <div :class="['theme-' + course.color_theme, {'highlighted': highlight_hash}]">
        <SmoothReflow>
            <div class="module-wrapper" :data-module="module.name" :class="[course.module_theme + '-module-theme', {'tw-items-center': noDashboard}]">
                <Link :to="url" :target="target" class="module-status-wrapper" v-if="course.numbered">
                    <div class="tw-relative">
                        <svg width="100%" height="100%" viewBox="0 0 42 42" class="progress-ring-wrapper" :class="{'no-color': $settings('membership.show_progress') === '0'}">
                            <circle class="progress-hole" cx="21" cy="21" r="15.91549430918954" fill="#f7fafc"></circle>
                            <circle class="progress-ring" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke-width="1.7"></circle>
                            <circle class="progress-segment" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke-width="1.7" :stroke-dasharray="strokeAnimation" stroke-dashoffset="25"></circle>
                        </svg>
	                    <div class="module-status" :class="{'locked mimic-title': !course.availability.available || (!course.is_released && !$user.isModerator) || !module.available}">
                            <h3 v-text="index+1"></h3>
                            <i class="fa fa-lock"></i>
                            <span v-if="course_available && !module.available && unlocksAt !== null">{{ $t('membership.unlocks_at') }} {{ unlocksAt }}</span>
                        </div>
                    </div>
                    <div class="tracker" v-if="modulesLength > 1"></div>
                </Link>
                <div class="module-content" :class="{'is-lesson': noDashboard}">
                    <Link :to="url" :target="target" class="tw-flex">
                        <i class="fa fa-check tw-text-green-500 tw-mr-2 tw-pt-1" v-if="!course.numbered && moduleProgress === 100"></i>
	                    <i class="fa fa-lock tw-self-center tw-text-gray-500 tw-mr-2 tw-pt-px" v-if="!course.numbered && (!course.availability.available || !course.is_released || !module.available)"></i>
                        <h2 class="tw-text-gray-800 tw-text-lg tw-font-semibold tw-simple-hover" :class="!noDashboard ? 'tw-mt-1 tw-pt-px' : 'tw-mt--1'" v-text="!noDashboard ? module.name : lesson.name"></h2>
                        <div v-if="noDashboard" class="module-lesson-type tw-flex tw-ml-2 tw-text-gray-400 tw-text-sm tw-pt-2px">
                            <i class="far fa-graduation-cap" v-if="lesson.content_kind === 'quiz'"></i>
                            <i class="far fa-play tw-pt-px" v-else-if="lesson.content_kind === 'video'"></i>
                            <i class="far fa-music tw-pt-px" v-else-if="lesson.content_kind === 'audio'"></i>
                            <i class="far fa-book tw-pt-1" v-else></i>
                            <span class="tw-pl-1 tw-capitalize" v-text="lesson.content_kind"></span>
                        </div>
                    </Link>
                    <p v-text="module.description" v-if="module.description && !noDashboard" class="tw-text-gray-600 tw-leading-relaxed tw-mt-3"></p>
                    <template v-if="lessonsLength > 0 && !noDashboard">
                        <span v-if="!expanded" class="tw-mt-4 tw-text-gray-400 tw-font-semibold tw-flex tw-items-center tw-simple-hover" @click="expanded = true">
                            <i class="fa fa-angle-double-down tw-pr-2"></i>
                            {{ $t('general.show') }} {{ lessonsLength }} {{ $t('membership.lessons').toLowerCase() }}
                        </span>
                        <div v-if="expanded" class="lessons tw-flex-col tw-mt-2">
                            <lesson v-for="lesson in module.lessons" :key="lesson.id" :lesson="lesson" :module="module" :course="course"></lesson>
                        </div>
                        <span v-if="expanded" class="tw-text-gray-400 tw-font-semibold tw-flex tw-items-center tw-mt-2 tw-simple-hover" @click="expanded = false">
                        <i class="fa fa-angle-double-up tw-pr-2"></i>
                        {{ $t('general.hide') }} {{ $t('membership.lessons') }}
                    </span>
                    </template>
                </div>
            </div>
        </SmoothReflow>
    </div>
</template>

<script>
    import Global from '../../mixins/Global'
    import Course from '../../mixins/v2/Course'
    import Modal from '../../mixins/v2/Modal';
    import Moment from '../../mixins/Moment';
    import Lesson from './Lesson.vue'
	import Link from "../Link.vue";

    export default {
        name: 'Module',

        mixins: [Course, Global, Modal, Moment],

        components: {
			Link,
			Lesson
		},

        props: ['course', 'module', 'index', 'modulesLength'],

        data() {
            return {
                loaded: false,
                expanded: false,
                highlight_hash: false,
                lesson_types: [
                    {
                        name_clean: 'video',
                        plural: 'videos',
                        icon: 'play'
                    },
                    {
                        name_clean: 'audio',
                        plural: 'audio files',
                        icon: 'music'
                    },
                    {
                        name_clean: 'text',
                        plural: 'worksheets',
                        icon: 'book'
                    },
                    {
                        name_clean: 'quiz',
                        plural: 'quizzes',
                        icon: 'graduation-cap'
                    }
                ],
            }
        },

        computed: {
			url() {
				if (!this.course.is_released && !this.$user.isModerator) {
					return '#';
				}

				if (!this.course.availability.available || !this.module.available) {
					if (!this.user && this.course.salespage === '' && (this.module.sales_page === '' || this.module.sales_page === null)) {
						return '/auth/login#login';
					} else if (this.module.available_from === null) {
						if (!this.module.available && this.module.sales_page !== '' && this.module.sales_page !== null) {
							return this.module.sales_page ?? '#';
						} else if (this.course.salespage !== '') {
							return this.course.salespage;
						}
					}
                } else if (this.module.lessons.length > 0) {
					return {
						name: 'lessons.show',
						params: {
							course_slug: this.course.slug,
							module_slug: this.module.slug,
							lesson_slug: this.module.lessons[0].slug,
						},
					};
                }

                return '#';
            },

            target() {
                return this.url !== '#' ? '_blank' : '_self';
            },

            lesson() {
				if (this.noDashboard && this.module.lessons.length > 0) {
					return this.module.lessons[0];
				}

				return false;
            },

            lessons() {
                let lessons = {};

                for(let i = 0; i < this.module.lessons.length; i++) {
                    if(typeof lessons[this.module.lessons[i].content_kind] === 'undefined') {
                        lessons[this.module.lessons[i].content_kind] = 1;
                    } else {
                        lessons[this.module.lessons[i].content_kind]++;
                    }
                }

                return lessons;
            },

            lessonsLength() {
                return this.module.lessons.length;
            },

            moduleProgress() {
                const finishedLessons = this.module.lessons.filter(lesson => lesson.seen).length;

                return Math.round((finishedLessons / this.module.lessons.length) * 100);
            },

            strokeAnimation() {
                return this.loaded ? this.moduleProgress + ' ' + (100 - this.moduleProgress) : '0 100';
            },

			// only count modules as no_dashboard if they only have 1 lesson (this wasnt always the case due to old legacy working of this feature)
			noDashboard() {
				return this.module.no_dashboard && this.module.lessons.length <= 1;
			},

            unlocksAt() {
                if (this.module.available_from === null) {
                    return null;
                }

                return moment(this.module.available_from).format("DD-MM-YYYY HH:mm");
            },
        },

        mounted() {
            setTimeout(() => {
                this.loaded = true;
            }, 0);

            let hash = window.location.hash;

            if (hash !== '') {
                hash = hash.substr(1);
                hash = decodeURI(hash);

                if (hash === this.module.name && $(".module-wrapper[data-module='" + hash + "']").length > 0) {
                    $('html, body').animate({scrollTop: $(".module-wrapper[data-module='" + hash + "']").offset().top}, 0);
                    this.expanded = true;
                    this.highlight_hash = true;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .module {
        transition: height 0.3s;

        .module-wrapper {
            @apply tw-flex tw-rounded tw-px-7 tw-py-4 tw-mb-2;

            .module-status-wrapper {
                flex-basis: 50px;

                .progress-ring-wrapper {
                    @apply tw-relative tw-z-10;
                    width: 42px;
                    height: 42px;
                    margin-left: -6px;
                    margin-top: -6px;

                    .progress-ring {
                        stroke: #e2e2e2;
                    }

                    &.no-color {
                        .progress-segment {
                            stroke: #e2e2e2 !important;
                        }
                    }
                }

                .module-status {
                    @apply tw-absolute tw-z-20 tw-flex tw-items-center tw-justify-center tw-rounded-full;
                    left: -1px;
                    top: 5px;
                    height: 33.33px;
                    width: 33.33px;

                    h3 {
                        @apply tw-text-base tw-font-bold;
                    }

                    i {
                        display: none;
                    }

                    span {
                        left: 0;
                        transform: none;
                    }

                    &.locked {
                        background: rgba(0, 0, 0, 0.5);

                        i {
                            display: block;
                        }

                        h3 {
                            display: none;
                        }
                    }
                }

                .tracker {
                    @apply tw-absolute tw-top-0;
                    background: #e2e2e2;
                    height: 9999px;
                    width: 2px;
                    left: 39px;

                    @screen md {
                        left: 49px;
                        width: 3px;
                    }
                }

                @screen md {
                    flex-basis: 75px;

                    .progress-ring-wrapper {
                        width: 63px;
                        height: 63px;
                    }

                    .module-status {
                        left: 1px;
                        top: 6px;
                        height: 50px;
                        width: 50px;

                        h3 {
                            @apply tw-text-xl;
                        }
                    }
                }
            }

            .module-content {
                @apply tw-flex tw-flex-col tw-flex-1 tw-pt-2;

				h2 {
					@apply tw-mb-0 tw-leading-relaxed #{!important};
				}

                .module-stats {
                    @apply tw-flex tw-items-center tw-text-gray-300 tw-mt-4 tw-font-semibold tw-uppercase;

                    .module-trophy {
                        flex-basis: 42px;
                    }

                    i {
                        @apply tw-pr-2;
                    }

                    img {
                        max-width: 35px;
                    }

                    .dot {
                        @apply tw-rounded-full;
                        height: 4px;
                        width: 4px;
                        background: #d3d4d6;
                        margin-left: 8px;
                    }

                    .attachments-download {
                        width: 22px;
                        height: 22px;

                        i {
                            padding-right: 0 !important;
                        }
                    }
                }

				&.is-lesson {
					@apply tw-pt-0;
				}
            }

            &.cards-module-theme {
                @apply tw-p-7 tw-mb-0;

				.module-content{
					&.is-lesson {
						@apply tw--mt-2;
					}
				}

                .module-status-wrapper {
                    @apply tw-mr-2;
                    flex-basis: auto;

                    .progress-ring-wrapper {
                        width: 50px;
                        height: 50px;
                    }

                    .module-status {
                        width: 40px;
                        height: 40px;

                        @screen md {
                            width: 37px;
                            height: 37px;
                        }
                    }

                    .tracker {
                        display: none;
                    }
                }

                .module-content {
                    @apply tw-pt-1;

                    a {
                        @apply tw-justify-between;

                        .module-trophy {
                            @apply tw-opacity-50 tw-order-2;

                            &:hover {
                                @apply tw-opacity-100;
                            }
                        }

                        h2 {
                            @apply tw-order-1 tw-leading-normal tw-text-base tw-flex-1;
                        }

                        .module-lesson-type {
                            @apply tw-order-2;

                            i {
                                padding-top: 0.25rem;
                                font-weight: 900;
                            }

                            span {
                                @apply tw-uppercase;
                                font-weight: 900;
                            }
                        }
                    }

                    p {
                        @apply tw-leading-loose tw-mt-2;
                    }
                }
            }
        }

        &:hover, &.highlighted {
            .module-wrapper {
                @apply tw-bg-gray-0;
                //box-shadow: 0px 8px 4px -3px #e2e5ea;
            }
        }

        &:first-of-type {
            .module-wrapper {
                .module-status-wrapper {
                    .tracker {
                        top: 45px;

                        @screen md {
                            top: 62px;
                        }
                    }
                }
            }
        }

        &:last-of-type {
            .module-wrapper {
                .module-status-wrapper {
                    .tracker {
                        height: 35px;
                    }
                }
            }
        }

        @mixin module-theme($light_color, $color) {
            .module-wrapper {
                .module-status-wrapper {
                    .progress-ring-wrapper {
                        .progress-segment {
                            transition: 2s;
                            stroke: $light_color;
                        }
                    }

                    .module-status {
                        h3 {
                            color: $color;
                        }
                    }
                }
            }
        }

        &.theme-teal {
            @include module-theme(#2ebda9, #27a291);
        }

        &.theme-pink {
            @include module-theme(#ff4c89, #E91E63);
        }

        &.theme-orange {
            @include module-theme(#ffb74c, #FF9800);
        }

        &.theme-blue {
            @include module-theme(#65b9fd, #2196F4);
        }

        &.theme-light_blue {
            @include module-theme(#81D4FA, #4FC3F7);
        }

        &.theme-red {
            @include module-theme(#EF5350, #E53935);
        }

        &.theme-purple {
            @include module-theme(#BA68C8, #9C27B0);
        }

        &.theme-deep_purple {
            @include module-theme(#9575CD, #673AB7);
        }

        &.theme-indigo {
            @include module-theme(#7986CB, #3F51B5);
        }

        &.theme-cyan {
            @include module-theme(#00BCD4, #0097A7);
        }

        &.theme-light_green {
            @include module-theme(#DCEDC8, #AED581);
        }

        &.theme-green {
            @include module-theme(#4CAF50, #388E3C);
        }

        &.theme-light_orange {
            @include module-theme(#E89A82, #EF7956);
        }

        &.theme-deep_orange {
            @include module-theme(#FF8A65, #FF5722);
        }

        &.theme-gray {
            @include module-theme(#616161, #212121);
        }

        &.theme-light_gray {
            @include module-theme(#97989c, #97989c);
        }

        &.theme-metallic {
            @include module-theme(#90A4AE, #607D8B);
        }

        &.theme-brown {
            @include module-theme(#A1887F, #795548);
        }
    }
</style>
